import React, { useEffect, useState,useRef } from "react";
import classes from "./PrepareRegister.module.scss";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import { useNavigate } from "react-router-dom";
import Header from "../../molecules/header/Header"
import headerImage from "../../static/images/prepare-header.png";
import TopSummary from "../../organism/top-summary/TopSummary";
import charSubHeader1 from "../../static/images/prepare/char-subheader1.png";
import charSubHeader2 from "../../static/images/prepare/char-subheader2.png";
import charSubHeader3 from "../../static/images/prepare/char-subheader3.png";
import buttonChar1 from "../../static/images/prepare/char-button1.png";
import buttonChar2 from "../../static/images/prepare/char-button2.png";
import TeacherComment from "../../molecules/teacher-commnet/TeacherComment";
import teacherOk from "../../static/images/teacher-comment.png";
import vectorUpImage from "../../static/images/prepare/vectorUpImage.png";
import vectorDownImage from "../../static/images/prepare/vectorDownImage.png";
import prepareBanner1 from "../../static/images/prepare/prepareBanner-1.png";
import checkedIcon from "../../static/images/prepare/checked.png"
import arrowDown from "../../static/images/prepare/arrowDown.png"

import { useLoginStatus } from "../../common/hooks/useLoginStatus";
import line from "../../static/images/dashed-line.png";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import { atom, useAtom } from "jotai";
import { fetchPrepareContent,PrepareContent,fetchUnregisteredPrepareContent } from "../../api/UserPrepareApi";

export const emailAtom = atom<string | undefined>(undefined);

function PrepareRegister() {

  const navigate = useNavigate();
  const { isLoggedIn, refresh } = useLoginStatus();
  const prepareContentApi = fetchPrepareContent();
  const prepareUnregisteredContentApi = fetchUnregisteredPrepareContent();
  const [prepareContent, setPrepareContent] = useState<PrepareContent>();

  useEffect(() => {
    // まだ判定中なら何もしない
    if (isLoggedIn === null) return;

    if (isLoggedIn) {
      prepareContentApi.fetch();
    } else {
      prepareUnregisteredContentApi.fetch();
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (prepareContentApi.state?.data == null) {
      return;
    }
    setPrepareContent(prepareContentApi.state.data[0]);
  }, [prepareContentApi.state?.data]);

  useEffect(() => {
    if (prepareUnregisteredContentApi.state?.data == null) {
      return;
    }
    setPrepareContent(prepareUnregisteredContentApi.state.data[0]);
  }, [prepareUnregisteredContentApi.state?.data]);

  const [isEducationCommentExpanded, setIsEducationCommentExpanded] = useState(false);
  const openEducationComment = () => {
    setIsEducationCommentExpanded(true);
  };

  const displayEducationComment = (() => {
    const comment = prepareContent?.childFinancialLongComment || "";
    if (comment == "") {
      return ""
    }
    if (isEducationCommentExpanded) {
      return comment.slice(0, 500); // 最大400文字
    }
    return comment.slice(0, 100) + "…";
  })();

  const [isLifeCommentExpanded, setIsLifeCommentExpanded] = useState(false);
  const openLifeComment = () => {
    setIsLifeCommentExpanded(true);
  };

  const displayRetiredComment = (() => {
    const comment = prepareContent?.lifeFinancialLongComment || "";
    if (comment == "") return "";
    if (isLifeCommentExpanded) {
      return comment.slice(0, 500);
    }
    return comment.slice(0, 100) + "…";
  })();

  const getColorClassForChild = (type: string, currentType: string | undefined) => {
    if (currentType != null && type === currentType) {
      return "orange";
    }
    return "gray";
  };

  return (
    <div className={classes.container}>
      {isLoggedIn && <Header />}
      <div className={classes.body}>
        <img className={classes.header} src={headerImage} alt={headerImage} />
        <TeacherComment
          image={teacherOk}
          comment={[
            "ご回答いただき有難うございます♪",
            "あなたとお子さまに合った教育資金＆老後資金の目安と貯めるコツをお伝えします♪",
          ]}
        />
      </div>
      {/*ーーーー教育セクションーーーー*/}      
      <div className={classes.educationContents}>
        <div className={classes.header}>
            <TopSummary
              leftLogo={charSubHeader1}
              mainTitle="教育資金の目安&コツ"
            />
        </div>
        <div className={classes.educationPictureBlock}>
          <img className={classes.categoryPicture} src={prepareContent?.categoryImage} alt={prepareContent?.categoryImage} />
        </div>
        <div className={classes.educationCommentBlock}>
            {prepareContent?.parentComment}{prepareContent?.childComment}
        </div>
        <div className={classes.educationBlock}>
          <div className={classes.educationTtile}>教育資金の目安</div>
          <img className={classes.educationTtileImage} src={line} alt={line} />
          <div className={classes.educationTtile}>
            <span className={classes.amount}>{prepareContent?.educationMin.toLocaleString("ja-JP")}</span>
            <span className={classes.unit}>万円&nbsp;～&nbsp;</span>
            <span className={classes.amount}>{prepareContent?.educationMax.toLocaleString("ja-JP")}</span>
            <span className={classes.unit}>万円</span>
          </div>
          <div className={classes.iconRow}>
            <img className={classes.vectorIcon} src={vectorDownImage} alt="" />
          </div>
          <div className={`${classes.educationTtile} ${classes.bottomTight}`}>
            毎月の積立の目安  
            <div className={`${classes.educationSubTtile} ${classes.topTight}`}>
              （0歳〜高校卒業までの期間で試算）
            </div>
          </div>
          <div className={`${classes.educationTtile} ${classes.topTight}`}>
            <span className={classes.unit}>毎月</span>
            <span className={classes.amount}>{prepareContent?.monthlyInvestmentFrom.toLocaleString("ja-JP")}</span>
            <span className={classes.unit}>万円&nbsp;～&nbsp;</span>
            <span className={classes.unit}>毎月</span>
            <span className={classes.amount}>{prepareContent?.monthlyInvestmentTo.toLocaleString("ja-JP")}</span>
            <span className={classes.unit}>万円</span>
          </div>
        </div>
        <div className={classes.headerGreenCommnet}>
            お子さまの職業可能性
        </div>
        <img className={classes.headerImage} src={line} alt={line} />
        <div className={classes.jobList}> 
          <div className={classes.jobTitle}>たとえば・・・</div>
          {prepareContent?.jobList?.map((job, idx) => (
            <div key={idx} className={classes.jobCard}>
              <div className={classes.jobTitle}>{job.jobName}</div>
              <div className={classes.jobInfo}>
                <div className={classes.education}>
                  <div className={classes.greenLabel}>平均教育資金</div>
                    <span className={classes.greenAmount}>{job.avgEducationFee.toLocaleString("ja-JP")}</span>
                    <span className={classes.unit}>万円</span>
                </div>
                <div className={classes.income}>
                  <div className={classes.grayLabel}>平均年収額</div>
                    <span className={classes.grayAmount}>{job.avgSalary.toLocaleString("ja-JP")}</span>
                    <span className={classes.unit}>万円</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className={classes.headerGreenCommnet}>
            教育資金を貯めるコツ！
        </div>
        <img className={classes.headerImage} src={line} alt={line} />
        <div className={classes.educationCommentBlock}>
          {displayEducationComment.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </div>
        {!isEducationCommentExpanded && (
          <div className={classes.openCommentButtonBlock}>
            <img className={classes.teacherOpen} src={buttonChar1} />
            <SimpleButton id="openComment" width="50%" label="すべて読む" onClick={openEducationComment}/>
          </div>
        )}
        </div>
      {/*ーーーー老後セクションーーーー*/}      
      <div className={classes.retiredContents}>
        <div className={classes.header}>
            <TopSummary
              leftLogo={charSubHeader2}
              mainTitle="老後資金の目安&コツ"
              color="orange" 
            />
        </div>
        <div className={classes.retiredBlock}>
          <div className={classes.retiredTtile}>老後資金の準備</div>
          <img className={classes.retiredTtileImage} src={line} alt={line} />
          <div className={classes.retiredTtile}>
            <span className={classes.amount}>{prepareContent?.retiredMin.toLocaleString("ja-JP")}</span>
            <span className={classes.unit}>万円&nbsp;～&nbsp;</span>
            <span className={classes.amount}>{prepareContent?.retiredMax.toLocaleString("ja-JP")}</span>
            <span className={classes.unit}>万円</span>
          </div>
          <div className={classes.iconRow}>
            <img className={classes.vectorIcon} src={vectorUpImage} alt="" />
          </div>
          <div className={classes.retiredTtile}>
            毎月の生活費  
            <div className={classes.retiredSubTtile}>
              （医療費・介護費は含まず）
            </div>
          </div>
          <div className={`${classes.retiredTtile} ${classes.topTight}`}>
            <span className={classes.unit}>毎月</span>
            <span className={classes.amount}>{prepareContent?.monthlyExpenditureFrom.toLocaleString("ja-JP")}</span>
            <span className={classes.unit}>万円&nbsp;～&nbsp;</span>
            <span className={classes.unit}>毎月</span>
            <span className={classes.amount}>{prepareContent?.monthlyExpenditureTo.toLocaleString("ja-JP")}</span>
            <span className={classes.unit}>万円</span>
          </div>
          <div className={classes.retiredTtile}>セカンドライフの余暇度</div>
          <img className={classes.retiredTtileImage} src={line} alt={line} />
            <div className={classes.bar}>
              <div className={`${classes.barLeft}   ${classes[getColorClassForChild("1",prepareContent?.lifeLevelCategory[1])]}`}>きっちり</div>
              <div className={`${classes.barCenter} ${classes[getColorClassForChild("2",prepareContent?.lifeLevelCategory[1])]}`}>ほどほど</div>
              <div className={`${classes.barRight}  ${classes[getColorClassForChild("3",prepareContent?.lifeLevelCategory[1])]}`}>たっぷり</div>
            </div>
        </div>  
        <div className={classes.retiredCommentBlock}>
          {prepareContent?.lifeLevelComment}
          {prepareContent?.leisureLevelComment}
        </div>
        <div className={classes.headerOrangeCommnet}>
            老後資金を貯めるコツ！
        </div>
        <img className={classes.headerImage} src={line} alt={line} />
        <div className={classes.retiredCommentBlock}>
          {displayRetiredComment.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </div>
        {!isLifeCommentExpanded && (
          <div className={classes.openCommentButtonBlock}>
              <img className={classes.teacherOpen} src={buttonChar1} />
              <SimpleButton id="openComment" width="50%" label="すべて読む" onClick={openLifeComment}/>
          </div>
        )}
      </div>

      {/*ーーーーお金のプロサポートページ状況セクションーーーー*/}      
      <div className={classes.bannerContents}>
        <div className={classes.header}>
            <TopSummary
              leftLogo={charSubHeader3}
              mainTitle="あなたに合った資産形成"
            />
        </div>
        <img className={classes.bannerImage} src={prepareBanner1} alt={prepareBanner1}/>
        {/* 選択肢たチェックリスト表示*/}
        {prepareContent?.checkList?.length ? (
          <div className={classes.boxContainer}>
            <div className={classes.box}>
              <div className={classes.accordion}>
                <div
                  className={classes.accordionHeader}
                >
                  <img
                    className={classes.accordionIcon}
                    src={arrowDown}
                  />
                  <div className={classes.accordionText}>
                    あなたの資産形成チェックリスト
                  </div>
                </div>
              </div>
              {prepareContent.checkList.map((check, idx) => (
                <div key={idx} className={classes.boxItem}>
                  <div className={classes.boxHeader}>
                    <img
                      className={classes.checkicon}
                      src={checkedIcon}
                      alt="選択済"
                    />
                    <div className={classes.headerText}>
                      {check.checkText}
                    </div>
                  </div>
                  <div className={classes.boxContent}>
                    <div className={classes.boxContentHeaderGreen}>
                      おかねのプロが何をしてくれるの？
                    </div>
                    <div className={classes.boxContentText}>
                      {check.moneySupportComment}
                    </div>
                    <div className={classes.boxContentHeaderOrange}>
                      どんな効果が期待できるの？
                    </div>
                    <div className={classes.boxContentText}>
                      {check.expectedSupportComment}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
      <div className={classes.buttonArea}>
        <SimpleButton width={"90%"} label={"もう一回実施する"} onClick={() => navigate("/familynavi")} />
        <img className={classes.teacherBottom} src={buttonChar2} />
      </div>
      <div className={classes.body}>
        <div className={classes.bottomBlock}>
        </div>
        {isLoggedIn ? (
          <BreadCrumb
            data={[
              { displayName: "みらいいコンシェル", url: "/top" },
              { displayName: "家族の備えナビ", url: "/familynavi" },
            ]}
          />
        ) : (
          <BreadCrumb
            data={[
              { displayName: "みらいいコンシェル", url: "/top" },
              { displayName: "家族の備えナビ", url: "/familynavi" },
            ]}
          />
        )}
      </div>
    </div>
  );
}

export default PrepareRegister;
